import { render, staticRenderFns } from "./DecisionBlock.vue?vue&type=template&id=b1219c04&"
import script from "./DecisionBlock.vue?vue&type=script&lang=js&"
export * from "./DecisionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports